module.exports = __webpack_public_path__ + "img/chest_2.460c0dcd.png";